import axios from 'axios'
import urlHelper from './urlHelper'

const baseUrl = urlHelper('/api/userPageFavorite')

export default {
  getList () {
    return axios.get(baseUrl)
  },
  add (pageNumber) {
    return axios.post(baseUrl, { pageNumber: pageNumber })
  },
  delete (id) {
    return axios.delete(`${baseUrl}/${id}`)
  }
}



// WEBPACK FOOTER //
// ./src/api/userPageFavorite.js